module.exports = __webpack_public_path__ + "static/media/354.ca6cb499.svg";